import { createConsumer, Consumer } from "@rails/actioncable"

const consumer: Consumer = createConsumer()

export default consumer
